// Pure: turns one discovery response into the steps and notes the lookup
// panel shows. Discovery is ONE request, so the steps are not live progress;
// they are what the response says, revealed in order once it arrives.

export const lookupSteps = discovery => [
  { key: 'fetched', label: 'Fetched the discovery document', status: 'ok' },
  discovery.issuerMatches
    ? { key: 'issuer', label: 'Issuer matches exactly', status: 'ok' }
    : { key: 'issuer', label: 'Issuer does not match exactly', status: 'warn', detail: `The document says ${discovery.documentIssuer}` },
  discovery.endSessionEndpoint
    ? { key: 'signout', label: discovery.logoutFrameBlocked ? 'Sign-out endpoint published, blocks embedding' : 'Sign-out endpoint published', status: 'ok' }
    : { key: 'signout', label: 'No sign-out endpoint published', status: 'warn' },
  { key: 'claims', label: 'Read claims, scopes and sign-in methods', status: 'ok' }
]

const joinAnd = items => items.length < 2 ? items.join('') : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`

export const lookupNotes = ({ discovery, filled, usedClaims }) => {
  const notes = []

  if (filled.length) notes.push({ tone: 'ok', text: `Filled in ${joinAnd(filled)} from the issuer.` })

  ;(discovery.warnings || []).forEach(text => notes.push({ tone: 'warn', text }))

  const advertised = new Set(discovery.claimsSupported || [])
  usedClaims
    .filter(claim => advertised.size && !advertised.has(claim))
    .forEach(claim => notes.push({ tone: 'warn', text: `${claim} is used by your mappings or rules but not advertised by the issuer. Make sure the app registration sends it.`, jump: 'claims' }))

  return notes.length ? notes : [{ tone: 'ok', text: 'Everything the issuer publishes matches this connection.' }]
}
